module.exports = __webpack_public_path__ + "img/中国移动.2ddcaa1d.jpg";